/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// document.addEventListener("DOMContentLoaded", function(){
//     document.body.classList.add('use-fixed-atc-form');
// });
var myElement = document.querySelector('.ProductForm__BuyButtons button');
if(myElement){
   myElement.addEventListener('click', (event) => {
   setInterval(function(){
      if(document.querySelector('#variant_upsell')){
         var variant_select = JSON.parse(document.querySelector('#variant_upsell').textContent);
          var select_option = Array.from(document.querySelectorAll('select'), (select) => select.value);
          const filtered = variant_select.reduce((a, o) => (o.option1 == select_option[0] && a.push(o.id), a), []);
          const addButton = document.querySelector('.drawer-upsell-product .Button');
          addButton.dataset.productId = filtered;
      }
   }, 1000);
});
}
